import { useEffect, useContext, useState, useMemo, useRef } from "react"
import fetchOptionsBuilder from "../../fetchOptionBuilder";
// import { useCookies } from "react-cookie";
import WorkflowContext from "../../workflowContext";
// import { InputText } from "primereact/inputtext";
// import { InputNumber } from "primereact/inputnumber";
// import { InputTextarea } from "primereact/inputtextarea";
// import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
// import { all } from "axios";
import Pagination from "../../components/Pagination";
import { Link } from "react-router-dom";

function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
        return defaultValue;
    }
    return JSON.parse(stored);

}    

export default function Query() {
    // const [cookies, setCookie, removeCookie] = useCookies(['auth', 'userid']);
    // const [check2, setCheck2] = useState(false);
    const workflow = useContext(WorkflowContext);
    const [data, setData] = useState({});
    const [selectedProperties, setSelectedProperties] = useState([null]);
    const [propVals, setPropVals] = useState([]);
    const [selectedSus, setSelectedSus] = useState([null]);
    const [susVals, setSusVals] = useState([]);
    const [selectedAmrCategories, setSelectedAmrCategories] = useState([null]);
    const [amrVals, setAmrVals] = useState([]);
    const [selectedVfCategories, setSelectedVfCategories] = useState([null]);
    const [vfVals, setVfVals] = useState([]);
    const [allStrains, setAllStrains] = useState([]);
    const [filteredStrainNames, setFilteredStrainNames] = useState(new Set());
    const [sortBy, setSortBy] = useState(1);
    const [sortDir, setSortDir] = useState([0,0,0,0]);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const tableRef = useRef(null);

    const headerMap = {
        'Strain ID': 'strain',
        'Name': 'name',
        'Sequence Type': 'sequence_type',
        'Location': 'latitude'
    }
    const tableHeaders = Object.keys(headerMap);

    const filteredStrainData = allStrains.filter(strain => filteredStrainNames.has(strain.strain))
    filteredStrainData.sort((a, b) => {
        if (!a[headerMap[tableHeaders[sortBy]]] && !b[headerMap[tableHeaders[sortBy]]]) return 0;
        if (!a[headerMap[tableHeaders[sortBy]]]) return 1;
        if (!b[headerMap[tableHeaders[sortBy]]]) return -1;
        // handles nums vs strings
        let x;
        if (sortBy > 1) {
            x = b[headerMap[tableHeaders[sortBy]]] - a[headerMap[tableHeaders[sortBy]]];
        } else {
            x = String(a[headerMap[tableHeaders[sortBy]]]).localeCompare(String(b[headerMap[tableHeaders[sortBy]]]));
        }
        return sortDir[sortBy] ? -x : x;
    })

    const currentTableData = useMemo(() => {
        const firstPageIndex = (parseInt(currentPage) - 1) * parseInt(pageSize);
        const lastPageIndex = parseInt(firstPageIndex) + parseInt(pageSize);
        return filteredStrainData.slice(parseInt(firstPageIndex), parseInt(lastPageIndex));
    }, [currentPage, pageSize, filteredStrainData]);

    const handleSelectionChange = (e) => {
        const parsedNum = parseInt(e.target.value)
        setPageSize(parsedNum)
    };

    const changeSort = col => {
        setSortBy(col);
        const newSortDir = [...sortDir];
        newSortDir[col] = 1 - sortDir[col];
        setSortDir(newSortDir);
    }

    const renderTableRow = (data) => {
        return (
            <tr>
                <td id="cell_1"><Link id="link" to={`/strains/detail/${data.strain}`}>{data.strain}</Link></td>
                <td id="cell_2"><Link id="link" to={`/strains/detail/${data.strain}`}>{data.name}</Link></td>
                <td id="cell_3">{data.sequence_type}</td>
                <td id="cell_4">{data.latitude}, {data.longitude}</td>
            </tr>
        );
    }

    const [apitoken, setApitoken] = useState(             // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('apitoken', null)
    );

    const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));    

    useEffect(() => {
        fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + 'strainqueryform', fetchOptionsBuilder(apitoken, workflow, getDataUserId))
            .then(res => res.json())
            .then(data => setData(data));
        fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + "strains/json", fetchOptionsBuilder(apitoken, workflow, getDataUserId))
            .then(res => res.json())
            .then(data => {
                setAllStrains(data);
            });
    }, [workflow, apitoken, getDataUserId]);

    useEffect(() => {
        if (tableRef.current) {
          tableRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }, [filteredStrainNames]);

    const editGroup = (group, setter, i, val) => {
        const newGroup = [...group];
        newGroup[i] = val;
        setter(newGroup);
    }

    const deleteEntry = (group, setter, valGroup, valSetter, i) => {
        const newGroup = [...group];
        const newValGroup = [...valGroup];
        newGroup.splice(i, 1);
        newValGroup.splice(i, 1);
        setter(newGroup);
        valSetter(newValGroup);
    }

    const propertyDisplay = [];
    selectedProperties.forEach((prop, i) => {
        propertyDisplay.push(
            <div className="field mb-4 col-5 sm:col-4">
                <Dropdown className="h-100" id={`prop_${i}`} options={data.strainprop} value={prop} 
                    onChange={e => {
                        editGroup(propVals, setPropVals, i, null);
                        editGroup(selectedProperties, setSelectedProperties, i, e.value);
                    }}
                />
            </div>
        )
        propertyDisplay.push(
            <div className="field mb-4 col-5 sm:col-4">
                <MultiSelect id={`propval_${i}`} options={prop ? data.strainprop_values[prop] : []} value={propVals[i]} 
                    onChange={e => editGroup(propVals, setPropVals, i, e.value)}
                />
            </div>
        )
        propertyDisplay.push(
            <Button icon="pi pi-trash" className="h-100" onClick={() => deleteEntry(selectedProperties, setSelectedProperties, propVals, setPropVals, i)}/>
        )
    });

    const antibioticDisplay = [];
    selectedSus.forEach((antibiotic, i) => {
        antibioticDisplay.push(
            <div className="field mb-4 col-5 sm:col-4">
                <Dropdown className="h-100" id={`antibiotic_${i}`} options={data.amrsus} value={antibiotic} 
                    onChange={e => {
                        editGroup(susVals, setSusVals, i, null);
                        editGroup(selectedSus, setSelectedSus, i, e.value);
                    }}
                />
            </div>
        )
        antibioticDisplay.push(
            <div className="field mb-4 col-5 sm:col-4">
                <MultiSelect id={`antibioticval_${i}`} options={antibiotic ? data.sus_values : []} value={susVals[i]} 
                    onChange={e => editGroup(susVals, setSusVals, i, e.value)}
                />
            </div>
        )
        antibioticDisplay.push(
            <Button icon="pi pi-trash" className="h-25" onClick={() => deleteEntry(selectedSus, setSelectedSus, susVals, setSusVals, i)}/>
        )
    });

    const amrDisplay = [];
    selectedAmrCategories.forEach((cat, i) => {
        amrDisplay.push(
            <div className="field mb-4 col-5 sm:col-4">
                <Dropdown className="h-100" id={`amr_${i}`} options={data.amrgene_categories} value={cat} 
                    onChange={e => {
                        editGroup(amrVals, setAmrVals, i, null);
                        editGroup(selectedAmrCategories, setSelectedAmrCategories, i, e.value);
                    }}
                />
            </div>
        );
        amrDisplay.push(
            <div className="field mb-4 col-5 sm:col-4">
                <MultiSelect id={`amrval_${i}`} options={cat ? data.amrgenes_values[cat] : []} value={amrVals[i]} 
                    onChange={e => editGroup(amrVals, setAmrVals, i, e.value)}
                />
            </div>
        )
        amrDisplay.push(
            <Button icon="pi pi-trash" className="h-25" onClick={() => deleteEntry(selectedAmrCategories, setSelectedAmrCategories, amrVals, setAmrVals, i)}/>
        )
    });

    const vfDisplay = [];
    selectedVfCategories.forEach((cat, i) => {
        vfDisplay.push(
            <div className="field mb-4 col-5 sm:col-4">
                <Dropdown className="h-100" id={`vf_${i}`} options={data.vfgenes_categories} value={selectedVfCategories[i]} 
                    onChange={e => {
                        editGroup(vfVals, setVfVals, i, null);
                        editGroup(selectedVfCategories, setSelectedVfCategories, i, e.value);
                    }}
                />
            </div>
        )
        vfDisplay.push(
            <div className="field mb-4 col-5 sm:col-4">
                <MultiSelect id={`vfval_${i}`} options={cat ? data.vfgenes_values[cat] : []} value={vfVals[i]} 
                    onChange={e => editGroup(vfVals, setVfVals, i, e.value)}
                />
            </div>
        )
        vfDisplay.push(
            <Button icon="pi pi-trash" className="h-25" onClick={() => deleteEntry(selectedVfCategories, setSelectedVfCategories, vfVals, setVfVals, i)}/>
        )
    });

    const submitQuery = () => {
        const query = {
            strainprop: {},
            amrsus: {},
            amrgene: {},
            vfgene: {}
        };
        selectedProperties.forEach((prop, i) => {
            if (prop) query.strainprop[prop] = propVals[i];
        });
        selectedSus.forEach((antibiotic, i) => {
            if (antibiotic) query.amrsus[antibiotic] = susVals[i];
        });
        selectedAmrCategories.forEach((cat, i) => {
            if (cat) query.amrgene[cat] = amrVals[i];
        });
        selectedVfCategories.forEach((cat, i) => {
            if (cat) query.vfgene[cat] = vfVals[i];
        });
        const form = new FormData();
        form.append('workflow_id', workflow);
        form.append('user_id', getDataUserId);
        form.append('query', JSON.stringify(query));
        fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + 'strainquery', Object.assign(fetchOptionsBuilder(apitoken, workflow, getDataUserId), {
            body: form
        }))
            .then(res => res.json())
            .then(data => {
                const newFilteredStrainNames = new Set();
                data.forEach(strain => newFilteredStrainNames.add(strain.genome_id));
                setFilteredStrainNames(newFilteredStrainNames);
            })
            .catch(err => console.error('caught error', err));
    }

    return (
        <div>
            <div className="px-4 py-4 md:px-6 lg:px-8">
                <div className="text-900 font-medium text-900 text-xl mb-3">Query Strain</div>
                    <div className="surface-card p-4 shadow-2 border-round p-fluid">
                        <div className="grid formgrid p-fluid">
                            <div className="col-5 sm:col-4 mb-3">Strain Properties</div>
                            <div className="col-5 sm:col-4 mb-3">Value</div>
                            {propertyDisplay}
                            <div class="w-100"></div>
                            <Button icon="pi pi-plus" className="mb-3" onClick={() => editGroup(selectedProperties, setSelectedProperties, selectedProperties.length, null)}/>
                            <div className="surface-border border-top-1 opacity-50 mb-4 col-12"></div>
                            <div className="col-5 sm:col-4 mb-3">Antibiotic Susceptibility Profile</div>
                            <div className="col-5 sm:col-4 mb-3">Value</div>
                            {antibioticDisplay}
                            <div class="w-100"></div>
                            <Button icon="pi pi-plus" className="mb-3" onClick={() => editGroup(selectedSus, setSelectedSus, selectedSus.length, null)}/>
                            <div className="surface-border border-top-1 opacity-50 mb-4 col-12"></div>
                            <div className="col-5 sm:col-4 mb-3">AMR Genes</div>
                            <div className="col-5 sm:col-4 mb-3">Value</div>
                            {amrDisplay}
                            <div class="w-100"></div>
                            <Button icon="pi pi-plus" className="mb-3" onClick={() => editGroup(selectedAmrCategories, setSelectedAmrCategories, selectedAmrCategories.length, null)}/>
                            <div className="surface-border border-top-1 opacity-50 mb-4 col-12"></div>
                            <div className="col-5 sm:col-4 mb-3">Virulence Factors</div>
                            <div className="col-5 sm:col-4 mb-3">Value</div>
                            {vfDisplay}
                            <div class="w-100"></div>
                            <Button icon="pi pi-plus" className="mb-3" onClick={() => editGroup(selectedVfCategories, setSelectedVfCategories, selectedVfCategories.length, null)}/>
                        </div>
                    <Button label="Submit Query" className="w-auto" onClick={submitQuery}/>
                </div>
            </div>
            {Boolean(filteredStrainNames.size) && <div ref={tableRef}>
                <div className="header">
                    <h2>Table of Strains</h2>
                    <div className="subrow">
                        <div className="box1">
                            <p>Entries per page:</p>
                            <div className="select-wrap">
                            <select name="countPerPage" id="countPerPage" onChange={handleSelectionChange}>
                                    <option value="10">10</option>
                                    {filteredStrainData.length > 10 && <option value="20">20</option>}
                                    {filteredStrainData.length > 20 && <option value="30">30</option>}
                                    {filteredStrainData.length > 30 && <option value="40">40</option>}
                                    {filteredStrainData.length > 40 && <option value="50">50</option>}
                                </select>
                                <span> Viewing {((currentPage > 1 ? (currentPage - 1) : 0) * pageSize) + 1} to {(currentPage * pageSize) > filteredStrainData.length ? filteredStrainData.length : (currentPage * pageSize)} of {filteredStrainData.length} entries</span>
                            </div>
                        </div>
                    </div>
                </div>
                <table className="table">
                    <thead className="thead-dark">
                    <tr>
                        <th id="cell_1" scope="col" className={sortBy === 0 ? 'sort' : 'nosort'} onClick={() => changeSort(0)}>{tableHeaders[0]} {sortDir[0] ? '▲' : '▼'}</th>
                        <th id="cell_2" scope="col" className={sortBy === 1 ? 'sort' : 'nosort'} onClick={() => changeSort(1)}>{tableHeaders[1]} {sortDir[1] ? '▲' : '▼'}</th>
                        <th id="cell_3" scope="col" className={sortBy === 2 ? 'sort' : 'nosort'} onClick={() => changeSort(2)}>{tableHeaders[2]} {sortDir[2] ? '▲' : '▼'}</th>
                        <th id="cell_4" scope="col" className={sortBy === 3 ? 'sort' : 'nosort'} onClick={() => changeSort(3)}>{tableHeaders[3]} {sortDir[3] ? '▲' : '▼'}</th>
                    </tr>
                    </thead>
                    <tbody>
                        {currentTableData.map((data) => renderTableRow(data))}
                    </tbody>
                </table>
                <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    totalCount={filteredStrainData.length}
                    pageSize={pageSize}
                    onPageChange={page => setCurrentPage(page)}
                    rightArrowId={'StrainsOverview'}
                />
            </div>}
        </div>
    )
}